class CartDrawer extends DrawerComponent {
  constructor() {
    super();
    window.FoxKitSections = FoxTheme.utils.getSectionId(this);

    this.onCartRefreshListener = this.onCartRefresh.bind(this);
    this.getSectionToRenderListener = this.getSectionToRender.bind(this);
  }

  get requiresBodyAppended() {
    return false;
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('cart:grouped-sections', this.getSectionToRenderListener);
    document.addEventListener('cart:refresh', this.onCartRefreshListener);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('cart:grouped-sections', this.getSectionToRenderListener);
    document.removeEventListener('cart:refresh', this.onCartRefreshListener);
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (this.open) {
      FoxTheme.a11y.trapFocus(this, this.focusElement);
    }
  }

  async onCartRefresh(event) {
    const cartId = `CartDrawer-${this.sectionId}`;

    const cartElement = document.getElementById(cartId);
    if (!cartElement) return;

    try {
      const response = await fetch(`${FoxTheme.routes.root_url}?section_id=${this.sectionId}`);
      const responseText = await response.text();

      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(responseText, 'text/html');

      const newCartContent = parsedHTML.getElementById(cartId).innerHTML;
      cartElement.innerHTML = newCartContent;

      if (event.detail?.open === true) {
        this.show();
      }
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );

    this.cartItemProducts = this.querySelectorAll('.cart-item__product');
    this.cartItemQuantitys = this.querySelectorAll('.cart-item__quantity');

    const loadTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const template = element.querySelector('template');
        const templateContent = template && document.importNode(template.content, true);
        const parent = element.querySelector(parentSelector);

        if (parent && template && !parent.querySelector('.template-content')) {
          const contentWrapper = document.createElement('div');
          contentWrapper.classList.add('template-content', 'w-full');
          contentWrapper.appendChild(templateContent);
          parent.appendChild(contentWrapper);
        }
      });
    };

    const removeTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const parent = element.querySelector(parentSelector);
        const templateContent = parent?.querySelector('.template-content');

        if (templateContent) {
          parent.removeChild(templateContent);
        }
      });
    };

    const handleTabletMatch = () => {
      loadTemplateContent(this.cartItemProducts, '.cart-item__product--info');
      removeTemplateContent(this.cartItemQuantitys, '.cart-item__quantity-wrapper');
    };

    const handleTabletUnmatch = () => {
      removeTemplateContent(this.cartItemProducts, '.cart-item__product--info');
      loadTemplateContent(this.cartItemQuantitys, '.cart-item__quantity-wrapper');
    };

    const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
    FoxTheme.config.mqlTablet = mqlTablet.matches;

    if (FoxTheme.config.mqlTablet) {
      handleTabletMatch();
    } else {
      handleTabletUnmatch();
    }

    mqlTablet.onchange = (event) => {
      if (event.matches) {
        handleTabletMatch();
      } else {
        FoxTheme.config.mqlTablet = false;
        handleTabletUnmatch();
      }
    };

    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
  }

  cartUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  setValidity(target, message) {
    target.setCustomValidity(message);
    target.reportValidity();
    target.value = target.defaultValue;
    target.select();
  }

  validateQuantity(event) {
    const target = event.target;
    const inputValue = parseInt(target.value);
    const index = target.getAttribute('data-index');
    let message = '';

    if (inputValue < parseInt(target.getAttribute('data-min'))) {
      message = FoxTheme.quickOrderListStrings.min_error.replace('[min]', target.getAttribute('data-min'));
    } else if (inputValue > parseInt(target.max)) {
      message = FoxTheme.quickOrderListStrings.max_error.replace('[max]', target.max);
    } else if (inputValue % parseInt(target.step) !== 0) {
      message = FoxTheme.quickOrderListStrings.step_error.replace('[step]', target.step);
    }

    if (message) {
      this.setValidity(target, message);
    } else {
      target.setCustomValidity('');
      target.reportValidity();
      this.updateQuantity(index, inputValue, document.activeElement.getAttribute('name'), target);
    }
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    const sectionId = FoxTheme.utils.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(event.cart.sections[sectionId], 'text/html');

    const cartDrawer = document.querySelector(`#CartDrawer-${sectionId}`);
    const cartDrawerBody = document.querySelector(`#CartDrawerBody-${sectionId}`);
    const cartDrawerFooter = document.querySelector(`#CartDrawerFooter-${sectionId}`);
    const cartDrawerEmpty = document.querySelector(`#CartDrawerEmpty-${sectionId}`);
    if (cartDrawer) {
      // const updatedElement = sectionToRender.querySelector(`#CartDrawer-${sectionId}`);
      // if (updatedElement) {
      //   cartDrawer.innerHTML = updatedElement.innerHTML;
      // }
      const cartDrawerBodyUpdate = sectionToRender.querySelector(`#CartDrawerBody-${sectionId}`);
      const cartDrawerFooterUpdate = sectionToRender.querySelector(`#CartDrawerFooter-${sectionId}`);
      const cartDrawerEmptyUpdate = sectionToRender.querySelector(`#CartDrawerEmpty-${sectionId}`);

      if (cartDrawerBodyUpdate) {
        cartDrawerBody.innerHTML = cartDrawerBodyUpdate.innerHTML;
      }
      if (cartDrawerFooterUpdate) {
        cartDrawerFooter.innerHTML = cartDrawerFooterUpdate.innerHTML;
      }

      if (cartDrawerEmptyUpdate) {
        cartDrawerEmpty.innerHTML = cartDrawerEmptyUpdate.innerHTML;
      }

      if (event.cart.item_count > 0) {
        cartDrawerBody.classList.remove('hidden');
        cartDrawerFooter.classList.remove('hidden');
        cartDrawerEmpty.classList.add('hidden');
      } else {
        cartDrawerBody.classList.add('hidden');
        cartDrawerFooter.classList.add('hidden');
        cartDrawerEmpty.classList.remove('hidden');
      }
    }

    const mainCart = document.querySelector(`#MainCart-${sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(`#MainCart-${sectionId}`);
      if (updatedElement) {
        mainCart.innerHTML = updatedElement.innerHTML;
      } else {
        mainCart.closest('.cart').classList.add('is-empty');
        mainCart.remove();
      }
    }

    const lineItem =
      document.getElementById(`CartItem-${event.line}`) || document.getElementById(`CartDrawer-Item-${event.line}`);

    if (lineItem && lineItem.querySelector(`[name="${event.name}"]`)) {
      FoxTheme.a11y.trapFocus(mainCart || cartDrawer, lineItem.querySelector(`[name="${event.name}"]`));
    } else if (event.cart.item_count === 0) {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector('a'))
        : FoxTheme.a11y.trapFocus(document.querySelector('.cart__empty'), document.querySelector('a'));
    } else {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector('.cart-item__title'))
        : FoxTheme.a11y.trapFocus(mainCart, mainCart.querySelector('.cart-item__title'));
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: event.cart,
        },
      })
    );
  }

  onCartError(errors, target) {
    if (target) {
      this.hideLoader(target.getAttribute('data-index'));
      this.setValidity(target, errors);
      return;
    } else {
      window.location.href = FoxTheme.routes.cart_url;
    }

    alert(errors);
  }

  updateQuantity(line, quantity, name, target) {
    this.showLoader(line);

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle,
    });

    fetch(`${FoxTheme.routes.cart_change_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          sources: 'cart-items',
          cart: parsedState,
          target,
          line,
          name,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showLoader(line) {
    const sectionId = FoxTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.add('btn--loading');
      });
    }
  }

  hideLoader(line) {
    const sectionId = FoxTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.remove('btn--loading');
      });
    }
  }

  setValidity(target, message) {
    target.setCustomValidity(message);
    target.reportValidity();
    target.value = target.defaultValue;
    target.select();
  }
}

customElements.define('cart-items', CartItems);

class CartRemoveItem extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-item', CartRemoveItem, { extends: 'a' });

class CartAddonModal extends ModalComponent {
  constructor() {
    super();
  }

  /**
   * To avoid lost focus input elements
   */
  get focusElement() {
    return this.querySelector('input, textarea, select') || this.querySelector('button');
  }
}
customElements.define('cart-addon-modal', CartAddonModal);

class CartAddonAccordion extends AccordionDetails {
  constructor() {
    super();
  }

  get focusElement() {
    return this.querySelector('input, textarea, select') || this.querySelector('button');
  }

  handleAfterAnimated() {
    if (this.open) FoxTheme.a11y.trapFocus(this, this.focusElement);
  }
}
customElements.define('cart-addon-accordion', CartAddonAccordion, { extends: 'details' });

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', FoxTheme.utils.debounce(this.onChange.bind(this), 300));

    if (this.button && this.cartNoteDetailsSummary) {
      this.button.addEventListener('click', () => {
        this.cartNoteDetailsSummary.close();
      });
    }
  }

  get cartNoteDetailsSummary() {
    return this.closest('[is="accordion-details"]');
  }

  get button() {
    return this.querySelector('[type="button"]');
  }

  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } });
  }
}
customElements.define('cart-note', CartNote);
class CartDiscount extends HTMLFormElement {
  constructor() {
    super();

    this.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  get submitEl() {
    return (this._submitEl = this._submitEl || this.querySelector('[type="submit"]'));
  }

  get messageEl() {
    return (this._messageEl = this._messageEl || this.querySelector('.form__message'));
  }

  get couponEl() {
    return (this._couponEl = this._couponEl || this.querySelector('input[name="discount"]'));
  }

  get cartAddonDrawer() {
    return this.closest('.cart-addons-drawer');
  }

  get cartDiscountsEl() {
    return document.querySelector('.cart__discounts');
  }

  getDiscounts() {
    const discounts = [];

    if (this.cartDiscountsEl) {
      const items = this.cartDiscountsEl.querySelectorAll('.cart__discount');
      items &&
        items.forEach((item) => {
          discounts.push(item.dataset.discountCode);
        });
    }

    return discounts;
  }

  handleFormSubmit(event) {
    event.preventDefault();

    if (this.submitEl.getAttribute('aria-disabled') === 'true') return;

    this.displayFormErrors();

    const newDiscountCode = this.couponEl.value;
    const discounts = this.getDiscounts();

    if (discounts.includes(newDiscountCode)) {
      this.displayFormErrors(FoxTheme.cartStrings.duplicateDiscountError);
      return;
    }

    discounts.push(newDiscountCode);

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('sections', sectionsToBundle);
    formData.append('sections_url', window.location.pathname);
    formData.append('discount', discounts.join(','));

    config.body = formData;

    this.submitEl.setAttribute('aria-disabled', 'true');
    this.submitEl.classList.add('btn--loading');

    fetch(FoxTheme.routes.cart_update_url, config)
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (
          parsedState.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
            return discount.code === newDiscountCode && discount.applicable === false;
          })
        ) {
          this.couponEl.value = '';
          this.displayFormErrors(FoxTheme.cartStrings.applyDiscountError);
          return;
        }

        if (this.cartAddonDrawer) {
          this.cartAddonDrawer.hide();
        }

        const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
        cartJson['sections'] = parsedState['sections'];

        this.updateCartState(cartJson);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitEl.removeAttribute('aria-disabled');
        this.submitEl.classList.remove('btn--loading');
      });
  }

  updateCartState = (cartJson) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  };

  displayFormErrors = (errorMessage = false) => {
    if (!this.messageEl) {
      if (errorMessage !== false) {
        alert(errorMessage);
      }
    } else {
      this.messageEl.classList.toggle('!hidden', !errorMessage);
      if (errorMessage !== false) {
        this.messageEl.innerText = errorMessage;
      }
    }
  };
}
customElements.define('cart-discount', CartDiscount, { extends: 'form' });

class CartDiscountRemove extends HTMLButtonElement {
  constructor() {
    super();

    this.selectors = {
      list: '.discounts',
      item: '.discount',
    };

    this.clickHandler = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.listEl = this.closest(this.selectors.list);

    this.addEventListener('click', this.clickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);
  }

  handleClick(event) {
    event.preventDefault();
    if (this.getAttribute('aria-disabled') === 'true') return;

    this.setAttribute('aria-disabled', 'true');
    this.classList.add('btn--loading');

    this.discounts = [];

    const thisItem = this.closest('li');
    const items = this.listEl.querySelectorAll(this.selectors.item);
    items &&
      items.forEach((item) => {
        if (item != thisItem) {
          this.discounts.push(item.dataset.discountCode);
        }
      });

    this.updateCartDiscounts();
  }

  updateCartDiscounts() {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('sections', sectionsToBundle);
    formData.append('sections_url', window.location.pathname);
    formData.append('discount', this.discounts.join(','));

    config.body = formData;

    fetch(FoxTheme.routes.cart_update_url, config)
      .then((response) => response.json())
      .then(async (parsedState) => {
        const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
        cartJson['sections'] = parsedState['sections'];

        this.updateCartState(cartJson);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateCartState = (cartJson) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  };
}
customElements.define('cart-discount-remove', CartDiscountRemove, { extends: 'button' });

class CalculateShipping extends CartAddonModal {
  constructor() {
    super();
    this.countryProvince = this.querySelector('country-province');
    this.isCountrySetup = false;
  }
  static get observedAttributes() {
    return [...super.observedAttributes, 'data-show'];
  }
  show() {
    super.show();
    this.setAttribute('data-show', true);
  }

  hide() {
    super.hide();
    this.setAttribute('data-show', false);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === 'data-show' && newValue === 'true' && !this.isCountrySetup && this.countryProvince) {
      const template = this.countryProvince.querySelector('template');
      const templateContent = document.importNode(template.content, true);
      this.countryProvince.countryElement.appendChild(templateContent);
      this.countryProvince.init();
      this.isCountrySetup = true;
    }
  }
}
customElements.define('calculate-shipping', CalculateShipping);
class CountryProvinceForm extends HTMLElement {
  constructor() {
    super();
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.template = this.dataset.template;
    this.countryElement.addEventListener('change', this.handleCountryChange.bind(this));
    if (this.template && this.template === 'cart') {
      this.init();
    }
  }

  init() {
    if (this.getAttribute('country') !== '') {
      this.countryElement.selectedIndex = Math.max(
        0,
        Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.dataset.country)
      );
      this.countryElement.dispatchEvent(new Event('change'));
    } else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option = this.countryElement.options[this.countryElement.selectedIndex],
      provinces = JSON.parse(option.dataset.provinces);

    this.provinceElement.closest('.form-field').hidden = provinces.length === 0;

    if (provinces.length === 0) {
      return;
    }

    this.provinceElement.innerHTML = '';

    provinces.forEach((data) => {
      const selected = data[1] === this.dataset.province;
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
}
customElements.define('country-province', CountryProvinceForm);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;

    this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.classList.add('btn--loading');

    const body = JSON.stringify({
      shipping_address: { zip, country, province },
    });
    let sectionUrl = `${FoxTheme.routes.cart_url}/shipping_rates.json`;

    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...FoxTheme.utils.fetchConfig('javascript'), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        } else {
          this.formatError(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.classList.remove('btn--loading');
      });
  }

  formatError(errors) {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--error blocks-radius grid gap-2">
        <p class="font-body-bolder m-0">${FoxTheme.shippingCalculatorStrings.error}</p>
        <ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join('')}</ul>
      </div>
    `;
  }

  formatShippingRates(shippingRates) {
    const shippingRatesList = shippingRates.map(({ presentment_name, currency, price }) => {
      return `<li>${presentment_name}: ${currency} ${price}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert blocks-radius alert--${
        shippingRates.length === 0 ? 'error' : 'success'
      } grid gap-2 leading-tight">
        <p class="font-body-bolder m-0">${
          shippingRates.length === 0
            ? FoxTheme.shippingCalculatorStrings.notFound
            : shippingRates.length === 1
            ? FoxTheme.shippingCalculatorStrings.oneResult
            : FoxTheme.shippingCalculatorStrings.multipleResults
        }</p>
        ${
          shippingRatesList === ''
            ? ''
            : `<ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join('')}</ul>`
        }
      </div>
    `;
  }
}
customElements.define('shipping-calculator', ShippingCalculator, { extends: 'form' });

class CartDrawerProductsRecommendation extends HTMLElement {
  constructor() {
    super();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(this.init.bind(this), { timeout: 1500 });
    } else {
      const userAgent = navigator.userAgent;
      const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome');
      if (isSafari) {
        this.init();
      } else {
        FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '600px 0px 600px 0px' });
      }
    }
  }

  get slideContainer() {
    return this.querySelector('.swiper');
  }

  get sliderPagination() {
    return this.querySelector('.swiper-pagination');
  }

  get sliderNext() {
    return this.querySelector('.swiper-button-next');
  }

  get sliderPrev() {
    return this.querySelector('.swiper-button-prev');
  }

  init() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.shopify-section');

        if (sectionInnerHTML === null) {
          this.isLoading = false;
          return;
        }

        const recommendations = sectionInnerHTML.querySelector('cart-drawer-products-recommendation');
        if (recommendations && recommendations.innerHTML.trim().length) {
          const productCount = recommendations.querySelectorAll('.product-card');
          this.innerHTML = recommendations.innerHTML;
          this.initCarousel();
          if (productCount.length > 0) this.classList.remove('hidden');
          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: { element: this, slides: this.querySelectorAll('.swiper-slide') }
          }));
        } else {
          this.closest('.shopify-section').remove();
          this.classList.add('hidden');
          document.dispatchEvent(new CustomEvent('is-empty', { detail: { element: this } }));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initCarousel() {
    this.carousel = new FoxTheme.Carousel(this.slideContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      pagination: {
        el: this.sliderPagination,
        type: 'fraction',
      },
      navigation: {
        nextEl: this.sliderNext,
        prevEl: this.sliderPrev,
      },
    });

    this.carousel && this.carousel.init();
  }
}

customElements.define('cart-drawer-products-recommendation', CartDrawerProductsRecommendation);

class CartDrawerCombinedRecommendations extends HTMLElement {
  constructor() {
    super();
    this.allSlides = [];
    this.recommendationElements = [];
    this.isInitialized = false;
    this.uniqueProductIds = new Set();

    document.addEventListener('recommendations:loaded', this.handleRecommendationsLoaded.bind(this));
    document.addEventListener('is-empty', this.handleRecommendationsEmpty.bind(this));
  }

  get slideContainer() {
    return this.querySelector('.swiper');
  }

  get sliderNext() {
    return this.querySelector('.swiper-button-next');
  }

  get sliderPrev() {
    return this.querySelector('.swiper-button-prev');
  }

  handleRecommendationsLoaded(event) {
    const { element, slides } = event.detail;

    if (!this.recommendationElements.includes(element)) {
      this.recommendationElements.push(element);
    }

    slides.forEach(slide => {
      const productLink = slide.querySelector('a[href*="/products/"]');
      if (productLink) {
        const productId = this.extractProductId(productLink.href);

        if (productId && !this.uniqueProductIds.has(productId)) {
          this.uniqueProductIds.add(productId);
          this.allSlides.push(slide);
        }
      }
    });

    this.updateCombinedSwiper();
  }

  handleRecommendationsEmpty(event) {
    const element = event.detail.element;
    const index = this.recommendationElements.indexOf(element);
    if (index > -1) {
      this.recommendationElements.splice(index, 1);
    }
  }

  extractProductId(url) {
    const match = url.match(/\/products\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  updateCombinedSwiper() {
    if (this.allSlides.length === 0) {
      document.querySelector('.cart-drawer-recommendations-loader').classList.add('hidden');
      this.classList.add('hidden');
      return;
    }

    const wrapper = this.slideContainer?.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    wrapper.innerHTML = '';

    this.allSlides.forEach(slide => {
      const clonedSlide = slide.cloneNode(true);
      wrapper.appendChild(clonedSlide);
    });

    const prevButton = this.sliderPrev;
    const nextButton = this.sliderNext;

    if (this.allSlides.length > 1) {
      if (prevButton) prevButton.style.display = '';
      if (nextButton) nextButton.style.display = '';
    } else {
      if (prevButton) prevButton.style.display = 'none';
      if (nextButton) nextButton.style.display = 'none';
    }

    setTimeout(() => {
      this.classList.remove('hidden');
      if (!this.isInitialized) {
        this.initCarousel();
        this.isInitialized = true;
      }
      document.querySelector('.cart-drawer-recommendations-loader').classList.add('hidden');
    }, 500);
  }

  initCarousel() {
    if (!this.slideContainer) return;

    this.carousel = new FoxTheme.Carousel(this.slideContainer, {
      slidesPerView: 1.1,
      spaceBetween: 6,
      loop: false,
      navigation: {
        nextEl: this.sliderNext,
        prevEl: this.sliderPrev,
      },
    });

    this.carousel && this.carousel.init();
  }

  disconnectedCallback() {
    document.removeEventListener('recommendations:loaded', this.handleRecommendationsLoaded.bind(this));
    document.removeEventListener('is-empty', this.handleRecommendationsEmpty.bind(this));
  }
}

customElements.define('cart-drawer-combined-recommendations', CartDrawerCombinedRecommendations);

class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cart:grouped-sections', this.getSectionToRender.bind(this));
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }
}
customElements.define('main-cart', MainCart);

class FreeShippingGoal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      leftToSpend: '[data-left-to-spend]',
      progressFill: '[data-progress]',
      goalText: '.goal-text'
    };

    this.threshold1 = Number(this.getAttribute('data-threshold-1')) / 100;
    this.threshold2 = Number(this.getAttribute('data-threshold-2')) / 100;
    this.threshold3 = Number(this.getAttribute('data-threshold-3')) / 100;

    this.thresholds = [this.threshold1, this.threshold2, this.threshold3].filter(t => t > 0);
    this.maxThreshold = Math.max(...this.thresholds);

    this.progressFill = this.querySelector(this.selectors.progressFill);
    this.money_format = window.FoxTheme.settings.moneyFormat;

    this.rewardNames = {
      1: this.getAttribute('data-reward-1'),
      2: this.getAttribute('data-reward-2'),
      3: this.getAttribute('data-reward-3')
    };

    this.congratulationsText = this.getAttribute('data-congratulations-text');
    this.variant1Id = this.getAttribute('data-variant-1') || '';
    this.variant2Id = this.getAttribute('data-variant-2') || '';
    this.variant3Id = this.getAttribute('data-variant-3') || '';
    this.giftVariantByTier = {
      1: this.variant1Id,
      2: this.variant2Id,
      3: this.variant3Id,
    };
    this.currentLevel = 0;
    this.lastCart = null;
    this.isSyncingGift = false;
  }

  connectedCallback() {
    this.progressFill = this.querySelector('[data-progress]');

    const cartTotal = Number(this.dataset.cartTotal) || 0;
    this.updateShippingGoal(cartTotal);

    document.addEventListener('cart:grouped-sections', () => {
      this.disableCheckoutButtons();
    });

    document.addEventListener('cart:updated', async (event) => {
      this.lastCart = event.detail.cart;
      // const { items_subtotal_price = 0, total_discount = 0 } = this.lastCart || {};
      // this.updateShippingGoal(Math.max(0, items_subtotal_price - total_discount));
      // this.updateShippingGoal(event.detail.cart.items_subtotal_price);
      this.updateShippingGoal(event.detail.cart.total_price);
      this.maybeSyncGifts();
    });
    this.fetchInitialCart();
  }

  updateShippingGoal(amount) {
    if (amount > 0) {
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
      return;
    }

    this.cartTotal = amount / 100;

    let progressPercent = 0;

    const milestone1Percent = this.threshold1 > 0 ? (this.threshold1 / this.maxThreshold) * 100 : 0;
    const milestone2Percent = this.threshold2 > 0 ? (this.threshold2 / this.maxThreshold) * 100 : 0;

    if (this.threshold3 > 0 && this.cartTotal >= this.threshold3) {
      progressPercent = 100;
    } else if (this.threshold2 > 0 && this.cartTotal >= this.threshold2) {
      if (this.threshold3 > 0) {
        const remainingPercent = 100 - milestone2Percent;
        progressPercent = milestone2Percent + ((this.cartTotal - this.threshold2) / (this.threshold3 - this.threshold2)) * remainingPercent;
      } else {
        progressPercent = 100;
      }
    } else if (this.threshold1 > 0 && this.cartTotal >= this.threshold1) {
      if (this.threshold2 > 0) {
        const remainingPercent = milestone2Percent - milestone1Percent;
        progressPercent = milestone1Percent + ((this.cartTotal - this.threshold1) / (this.threshold2 - this.threshold1)) * remainingPercent;
      } else {
        progressPercent = 100;
      }
    } else if (this.threshold1 > 0) {
      progressPercent = (this.cartTotal / this.threshold1) * milestone1Percent;
    }

    let currentLevel = 0;
    let nextThreshold = this.threshold1;
    let nextReward = this.rewardNames[1];
    let isFinalThresholdReached = false;

    if (this.threshold1 > 0 && this.cartTotal >= this.threshold1) {
      currentLevel = 1;
      if (this.threshold2 > 0) {
        nextThreshold = this.threshold2;
        nextReward = this.rewardNames[2];
        if (this.cartTotal >= this.threshold2) {
          currentLevel = 2;
          if (this.threshold3 > 0) {
            nextThreshold = this.threshold3;
            nextReward = this.rewardNames[3];
            if (this.cartTotal >= this.threshold3) {
              currentLevel = 3;
              nextThreshold = this.threshold3;
              isFinalThresholdReached = true;
            }
          } else {
            nextThreshold = this.threshold2;
            isFinalThresholdReached = true;
          }
        }
      } else {
        nextThreshold = this.threshold1;
        isFinalThresholdReached = true;
      }
    } else if (this.threshold1 > 0) {
      nextThreshold = this.threshold1;
      nextReward = this.rewardNames[1];
    }

    this.currentLevel = currentLevel;
    this.updateMilestoneStates(currentLevel);

    const progressTrack = this.querySelector('.progress-track');
    if (progressTrack) {
      progressTrack.classList.remove('threshold-1-reached', 'threshold-2-reached', 'threshold-3-reached');

      if (currentLevel >= 3) {
        progressTrack.classList.add('threshold-3-reached');
      } else if (currentLevel >= 2) {
        progressTrack.classList.add('threshold-2-reached');
      } else if (currentLevel >= 1) {
        progressTrack.classList.add('threshold-1-reached');
      }
    }

    if (this.progressFill) {
      this.progressFill.style.width = `${progressPercent}%`;

      const threshold1Percent = this.threshold1 > 0 ? (this.threshold1 / this.maxThreshold) * 100 : 0;
      const threshold2Percent = this.threshold2 > 0 ? (this.threshold2 / this.maxThreshold) * 100 : 0;

      let gradientBackground = '';

      if (currentLevel >= 3) {
        gradientBackground = '#4caf50';
      } else if (currentLevel >= 2) {
        if (progressPercent <= threshold2Percent) {
          gradientBackground = '#4caf50';
        } else {
          const greenWidth = threshold2Percent;
          const darkWidth = progressPercent - threshold2Percent;
          const totalWidth = progressPercent;
          const greenPercent = (greenWidth / totalWidth) * 100;
          gradientBackground = `linear-gradient(to right, #4caf50 0%, #4caf50 ${greenPercent}%, #2c2c2c ${greenPercent}%, #2c2c2c 100%)`;
        }
      } else if (currentLevel >= 1) {
        if (progressPercent <= threshold1Percent) {
          gradientBackground = '#4caf50';
        } else {
          const greenWidth = threshold1Percent;
          const darkWidth = progressPercent - threshold1Percent;
          const totalWidth = progressPercent;
          const greenPercent = (greenWidth / totalWidth) * 100;
          gradientBackground = `linear-gradient(to right, #4caf50 0%, #4caf50 ${greenPercent}%, #2c2c2c ${greenPercent}%, #2c2c2c 100%)`;
        }
      } else {
        gradientBackground = '#2c2c2c';
      }

      this.progressFill.style.background = gradientBackground;
    }

    let remainingAmount = (nextThreshold - this.cartTotal) * 100;
    const leftToSpendEl = this.querySelector(this.selectors.leftToSpend);
    if (leftToSpendEl && remainingAmount > 0) {
      leftToSpendEl.innerHTML = FoxTheme.Currency.formatMoney(remainingAmount, this.money_format);
    } else if (leftToSpendEl && remainingAmount <= 0) {
      leftToSpendEl.innerHTML = FoxTheme.Currency.formatMoney(0, this.money_format);
    }

    this.updateGoalText(remainingAmount, nextReward, isFinalThresholdReached);
    this.maybeSyncGifts();
  }

  updateGoalText(remainingAmount, nextReward, isFinalThresholdReached = false) {
    const goalTextEl = this.querySelector(this.selectors.goalText);
    if (!goalTextEl) return;

    if (isFinalThresholdReached && this.congratulationsText) {
      goalTextEl.innerHTML = this.congratulationsText;
      return;
    }

    const translationKey = 'general.cart.free_shipping.remaining_html';
    let translatedText = '';

    if (window.FoxTheme && window.FoxTheme.translations && window.FoxTheme.translations[translationKey]) {
      translatedText = window.FoxTheme.translations[translationKey];
    } else {
      translatedText = this.getAttribute('data-fallback-text');
    }

    const formattedAmount = remainingAmount > 0 ?
      FoxTheme.Currency.formatMoney(remainingAmount, this.money_format) :
      '0';

    const updatedText = translatedText
      .replace('{{ remaining_amount }}', formattedAmount)
      .replace('{{ next_reward }}', nextReward);

    goalTextEl.innerHTML = updatedText;
  }

  updateMilestoneStates(currentLevel) {
    const milestones = this.querySelectorAll('.milestone-icon');

    milestones.forEach((milestone, index) => {
      const milestoneNumber = index + 1;

      milestone.classList.remove('milestone-achieved', 'milestone-next', 'milestone-pending');

      if (milestoneNumber <= currentLevel) {
        milestone.classList.remove('milestone-2', 'milestone-3');
        milestone.classList.add('milestone-1');
      } else {
        milestone.classList.remove('milestone-1');
        if (milestoneNumber === 2) {
          milestone.classList.add('milestone-2');
        } else if (milestoneNumber === 3) {
          milestone.classList.add('milestone-3');
        }
      }
    });
  }

  async fetchInitialCart() {
    try {
      const response = await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() });
      const cartJson = await response.json();
      this.lastCart = cartJson;
      this.maybeSyncGifts();
    } catch (error) {
      console.error('FreeShippingGoal: failed to fetch initial cart', error);
    }
  }

  getDesiredGiftVariantIds() {
    if (!this.currentLevel || this.currentLevel <= 0) return [];
    const desired = [];
    for (let tier = 1; tier <= this.currentLevel; tier++) {
      const vid = this.giftVariantByTier[tier];
      if (vid && String(vid) !== '0' && String(vid).trim() !== '') desired.push(String(vid));
    }
    return desired;
  }

  getGiftLinesInCart(itemIds = []) {
    if (!this.lastCart || !Array.isArray(this.lastCart.items)) return [];
    const giftLines = [];
    this.lastCart.items.forEach((item, index) => {
      const properties = item.properties || {};
      const isGift = Object.prototype.hasOwnProperty.call(properties, '_tier_gift');
      // If the item cannot be purchased by customer interaction
      const isGiftById = itemIds.some(id => id == item.variant_id);
      if (isGift || isGiftById) {
        giftLines.push({ line: index + 1, variantId: String(item.variant_id), quantity: item.quantity });
      }
    });
    return giftLines;
  }

  async maybeSyncGifts() {
    if (this.isSyncingGift) return;
    if (!this.lastCart) return;

    const desiredVariantIds = this.getDesiredGiftVariantIds();
    const allGiftVariantIds = Object.values(this.giftVariantByTier)
      .filter((vid) => vid && String(vid) !== '0' && String(vid).trim() !== '')
      .map(String);

    const giftLines = this.getGiftLinesInCart(allGiftVariantIds);

    const nonGiftItemCount = (this.lastCart.items || []).filter((item) => {
      const properties = item.properties || {};
      const hasProps = Object.prototype.hasOwnProperty.call(properties, '_tier_gift')
       // If the item cannot be purchased by customer interaction
      const isGiftById = allGiftVariantIds.some(id => id == item.variant_id)
      return !hasProps && !isGiftById
    }).length;


    if (nonGiftItemCount === 0 && giftLines.length > 0) {
      this.disableCheckoutButtons();
      this.isSyncingGift = true;
      try {
        for (const g of giftLines) {
          await this.removeGiftByVariantId(g.variantId);
        }
      } finally {
        this.isSyncingGift = false;
        this.enableCheckoutButtons();
      }
      return;
    }

    const existingCounts = giftLines.reduce((acc, g) => {
      acc[g.variantId] = (acc[g.variantId] || 0) + 1;
      return acc;
    }, {});

    const desiredSet = new Set(desiredVariantIds);
    const variantsToRemove = [];
    giftLines.forEach((g) => {
      if (!desiredSet.has(g.variantId)) {
        variantsToRemove.push(g.variantId);
      }
    });
    Object.keys(existingCounts).forEach((variantId) => {
      const extra = existingCounts[variantId] - 1;
      for (let i = 0; i < extra; i++) variantsToRemove.push(variantId);
    });

    const quantityCorrections = giftLines
      .filter((g) => desiredSet.has(g.variantId) && g.quantity !== 1)
      .map((g) => ({ line: g.line, quantity: 1 }));

    const variantsToAdd = desiredVariantIds.filter((vid) => (existingCounts[vid] || 0) === 0);

    if (variantsToRemove.length === 0 && variantsToAdd.length === 0 && quantityCorrections.length === 0) return;

    this.disableCheckoutButtons();
    this.isSyncingGift = true;
    try {
      for (const correction of quantityCorrections) {
        await this.setLineQuantity(correction.line, correction.quantity);
      }
      for (const variantId of variantsToRemove) {
        await this.removeGiftByVariantId(variantId);
      }
      for (const variantId of variantsToAdd) {
        await this.addGiftVariant(variantId);
      }
    } finally {
      this.isSyncingGift = false;
      this.enableCheckoutButtons();
    }
  }

  async addGiftVariant(variantId) {
    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const body = JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: { _tier_gift: 'true' },
          },
        ],
        sections: sectionsToBundle,
        section_url: window.location.pathname,
      });

      const response = await fetch(`${FoxTheme.routes.cart_add_url}`, {
        ...FoxTheme.utils.fetchConfig('javascript'),
        ...{ body },
      });
      const parsedState = await response.json();

      if (parsedState && !parsedState.status) {
        const cartResponse = await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() });
        const cartJson = await cartResponse.json();
        cartJson['sections'] = parsedState['sections'];
        this.lastCart = cartJson;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      }
    } catch (error) {
      console.error('FreeShippingGoal: failed to add gift', error);
    }
  }

  findGiftLineByVariantId(variantId) {
    if (!this.lastCart || !Array.isArray(this.lastCart.items)) return null;
    const allGiftVariantIds = Object.values(this.giftVariantByTier)
      .filter((vid) => vid && String(vid) !== '0' && String(vid).trim() !== '')
      .map(String);
    for (let i = 0; i < this.lastCart.items.length; i++) {
      const item = this.lastCart.items[i];
      const properties = item.properties || {};
      const isGift = Object.prototype.hasOwnProperty.call(properties, '_tier_gift');
      const isGiftById = allGiftVariantIds.includes(String(item.variant_id));
      if ((isGift || isGiftById) && String(item.variant_id) === String(variantId)) {
        return i + 1;
      }
    }
    return null;
  }

  async removeGiftByVariantId(variantId) {
    try {
      const line = this.findGiftLineByVariantId(variantId);
      if (!line) return;

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const body = JSON.stringify({ line, quantity: 0, sections: sectionsToBundle });
      const response = await fetch(`${FoxTheme.routes.cart_change_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        ...{ body },
      });
      const parsedState = await response.json();
      this.lastCart = parsedState;
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
    } catch (error) {
      console.error('FreeShippingGoal: failed to remove gift line', error);
    }
  }

  async setLineQuantity(line, quantity) {
    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );
      const body = JSON.stringify({ line, quantity, sections: sectionsToBundle });
      const response = await fetch(`${FoxTheme.routes.cart_change_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        ...{ body },
      });
      const parsedState = await response.json();
      this.lastCart = parsedState;
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
    } catch (error) {
      console.error('FreeShippingGoal: failed to set line quantity', error);
    }
  }

  disableCheckoutButtons() {
    try {
      const buttons = document.querySelectorAll('.checkout-btn');
      buttons.forEach((btn) => {
        btn.setAttribute('disabled', 'true');
        btn.setAttribute('aria-disabled', 'true');
      });
    } catch (error) {}
  }

  enableCheckoutButtons() {
    try {
      const buttons = document.querySelectorAll('.checkout-btn');
      buttons.forEach((btn) => {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      });
    } catch (error) {}
  }
}
customElements.define('free-shipping-goal', FreeShippingGoal);

window.FoxKitAddToCart = async (payload) => {
  if (!payload?.properties?.['_FoxKit offer']) return;

  const cartJson = await (
    await fetch(`${FoxTheme.routes.cart_url}`, {
      ...FoxTheme.utils.fetchConfig(),
    })
  ).json();
  cartJson['sections'] = payload['sections'];
  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

  document.dispatchEvent(
    new CustomEvent('product-ajax:added', {
      detail: {
        product: payload,
      },
    })
  );
};
